import { get } from "lodash";

export const getSuppliers = state => {
  return get(state, "pageContent.suppliers", undefined);
};

export default getSuppliers;
